
export enum Symbols {
    Key,
    Control
}

export enum Controls {
    Delete
}

export class Symbol {
    type: Symbols

    constructor(type: Symbols) {
        this.type = type;
    }
}

export class KeySymbol extends Symbol {
    key: String

    constructor(key: String) {
        super(Symbols.Key)
        this.key = key
    }
}

export class ControlSymbol extends Symbol {
    control: Controls

    constructor(control: Controls) {
        super(Symbols.Control)
        this.control = control
    }
}